import { Controller } from "stimulus"
import axios from 'axios'

export default class extends Controller {

  static targets = [
    ""
  ]

  click_edit_or_cancel(e) {
    e.preventDefault()
    axios.get(e.target.dataset.path)
      .then(response => {
        this.element.outerHTML = response.data
      })
  }

}